import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from "@angular/router";
import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
registerLocaleData(localePt, 'pt');

import { BnChannelsModule, BnHttpModule } from '@bndes/bndes-angular-utils';

import { CustomReuseStrategy } from "./custom-reuse-strategy";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FEATURES } from './feature';
//import { SharedModule } from '@smdapp/shared';

import { SharedModule } from './shared/shared.module';
import { FluxModule } from './flux';
import {ReCaptchaModule} from "angular2-recaptcha";
import { GuardService } from './shared/services/guard-service';


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    BnHttpModule.forRoot({ useCache: true }),
    BnChannelsModule.forRoot(),
    FluxModule,
    ...FEATURES,
    AppRoutingModule,
    ReCaptchaModule
  ],
  providers: [
    GuardService,
    { provide: LOCALE_ID, useValue: 'pt' },
    { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
